import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from '../../../lib/toast';
import { API, auth, inputCls, Field, Modal, PrimaryBtn, errMsg, fmtDate } from '../finance/shared';
import Icon from '../../../components/dashboard/DashboardIcons';
import CoachProfileModal from './CoachProfileModal';

export default function CoachCandidatesTab() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [requestModal, setRequestModal] = useState(null);
  const [reqForm, setReqForm] = useState({ position_title: '', message: '' });
  const [profileCoachId, setProfileCoachId] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try { const res = await axios.get(`${API}/coaches/candidates`, auth()); setItems(res.data); } catch { setItems([]); }
    setLoading(false);
  }, []);
  useEffect(() => { load(); }, [load]);

  const remove = async (id) => {
    try { await axios.delete(`${API}/coaches/candidates/${id}`, auth()); toast.success('تم الحذف من القائمة'); load(); }
    catch (err) { toast.error(errMsg(err, 'فشل الحذف')); }
  };

  const sendRequest = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/coaches/requests`, { coach_id: requestModal.coach_id, ...reqForm }, auth());
      toast.success('تم إرسال طلب التواصل');
      setRequestModal(null); setReqForm({ position_title: '', message: '' });
    } catch (err) { toast.error(errMsg(err, 'فشل إرسال الطلب')); }
  };

  return (
    <div className="space-y-4" data-testid="coach-candidates-tab">
      {loading ? <p className="text-sm text-slate-400">جارِ التحميل...</p> : items.length === 0 ? (
        <p className="rounded-xl border border-dashed border-slate-200 py-10 text-center text-sm text-slate-400" data-testid="coach-candidates-empty">لا يوجد مرشحون محفوظون بعد</p>
      ) : (
        <div className="space-y-2">
          {items.map((c) => (
            <div key={c.id} className="flex items-center justify-between rounded-xl border border-slate-200 bg-white p-4" data-testid="coach-candidate-row">
              <div>
                <div className="text-sm font-bold text-slate-800">{c.coach_name}</div>
                {c.internal_note && <div className="mt-1 text-xs text-slate-500">ملاحظة: {c.internal_note}</div>}
                <div className="text-[11px] text-slate-400">أُضيف في {fmtDate(c.created_at)}</div>
              </div>
              <div className="flex gap-2">
                <button onClick={() => setProfileCoachId(c.coach_id)} className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-600 hover:border-teal-300" data-testid="coach-candidate-profile-btn">السيرة الذاتية</button>
                <button onClick={() => setRequestModal(c)} className="rounded-lg bg-[#16233b] px-3 py-1.5 text-xs font-semibold text-white" data-testid="coach-candidate-request-btn">إرسال طلب تواصل</button>
                <button onClick={() => remove(c.id)} className="rounded-lg border border-slate-200 p-2 text-red-500 hover:border-red-300" data-testid="coach-candidate-delete-btn"><Icon name="trash" className="w-4 h-4" /></button>
              </div>
            </div>
          ))}
        </div>
      )}

      <Modal open={Boolean(requestModal)} title={`طلب تواصل مع ${requestModal?.coach_name || ''}`} onClose={() => setRequestModal(null)}>
        <form onSubmit={sendRequest} className="space-y-3">
          <Field label="المسمى / الدور المطلوب"><input className={inputCls} value={reqForm.position_title} onChange={(e) => setReqForm({ ...reqForm, position_title: e.target.value })} data-testid="candidate-request-input-title" /></Field>
          <Field label="رسالة (اختياري)"><textarea rows={3} className={inputCls} value={reqForm.message} onChange={(e) => setReqForm({ ...reqForm, message: e.target.value })} data-testid="candidate-request-input-message" /></Field>
          <div className="flex justify-end gap-2">
            <button type="button" onClick={() => setRequestModal(null)} className="rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-600">إلغاء</button>
            <PrimaryBtn type="submit" data-testid="coach-candidate-request-submit-btn">إرسال الطلب</PrimaryBtn>
          </div>
        </form>
      </Modal>
      <CoachProfileModal coachId={profileCoachId} onClose={() => setProfileCoachId(null)} />
    </div>
  );
}
